import React, { useState, useCallback, useEffect } from "react";
import { Box, Indicator, UnstyledButton } from "@mantine/core";
import { MdPeople } from "react-icons/md";
import { inviteFriends, openSocialModal } from "../../../../../Components/Modals";
import { useFriendsQuery } from "../../../../../Api/Queries/friendsQuery";
import { useFriendStatusUpdateTime } from "../../../Hooks";
import useAsyncEffect from "use-async-effect";
import { webPlayerStore } from "@app/Screens/WebPlayer/store/webPlayerStore";

const MAX_INDICATOR_COUNT = 99;

// TODO: ВНИМАНИЕ - ЭТО УЖАСНЫЙ ГОВНОКОД СГЕНЕРИРОВАННЫЙ chatgpt
// по сути надо проверить что GetFriends уже вызывался и если нет - вызывать
// дождаться ответа
// и только потом запрашивать друзей
// Так же - надо вобще не показывать кнопку пока fxidsdk не проинициализировался
export const SocialSection = () => {
	const [hasCalledGetFriends, setHasCalledGetFriends] = useState(false);
	const [triggerFriendsQuery, setTriggerFriendsQuery] = useState(false);
	const [friendStatusUpdateTime, setFriendStatusUpdateTime] = useFriendStatusUpdateTime();
	const friendStatusUpdateDate = new Date(friendStatusUpdateTime);
	const gameConfig = webPlayerStore((state) => state.gameConfig);

	const { data, refetch } = useFriendsQuery({ enabled: triggerFriendsQuery });

	useAsyncEffect(async () => {
		if (triggerFriendsQuery) {
			await refetch();
		}
	}, [triggerFriendsQuery, refetch]);

	const handleButtonClick = useCallback(async () => {
		if (window.FxIdSdk == null) {
			log.info("FxIdSdk not initialized");
			return;
		}

		if (!hasCalledGetFriends) {
			log.info("GetFriends has not been called - calling");
			try {
				const getFriendsResult = await window.FxIdSdk?.GetFriends("{}");
				log.info("getFriendsResult: %o", getFriendsResult);
				setHasCalledGetFriends(true);
				setTriggerFriendsQuery(true); // Trigger the re-fetch of the friends query
			} catch (error) {
				log.error("Error calling GetFriends:", error);
				return;
			}
		}

		if (data && data.length === 0) {
			await inviteFriends();
			return;
		}

		openSocialModal(gameConfig.GameSystemName);
		setFriendStatusUpdateTime(new Date().toISOString());
	}, [hasCalledGetFriends, data, gameConfig.GameSystemName, friendStatusUpdateTime]);

	const numberOfUpdates =
		data?.filter((f) => f.Game === gameConfig.GameSystemName && f.LastUpdatedAt > friendStatusUpdateDate).length ??
		0;

	const label = numberOfUpdates < MAX_INDICATOR_COUNT ? `${numberOfUpdates}` : `${MAX_INDICATOR_COUNT}+`;

	return (
		<Box>
			<UnstyledButton onClick={handleButtonClick}>
				<Indicator offset={6} label={label} disabled={numberOfUpdates < 1} color="red">
					<MdPeople size={24} fill="#fff" />
				</Indicator>
			</UnstyledButton>
		</Box>
	);
};
